import { render, staticRenderFns } from "./DeviceStatusControl.vue?vue&type=template&id=2f7a1b16&scoped=true"
import script from "./DeviceStatusControl.vue?vue&type=script&lang=js"
export * from "./DeviceStatusControl.vue?vue&type=script&lang=js"
import style0 from "./DeviceStatusControl.vue?vue&type=style&index=0&id=2f7a1b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a1b16",
  null
  
)

export default component.exports